// @ts-nocheck
import { useCallback, useState } from 'react';
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';

export const getChangeRequestFieldOptions = () => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_CHANGE_REQUEST_FIELD_OPTIONS}`
    )
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};
export default function useChangeRequestImpact() {
  const [openChangeRequestModal, setOpenChangeRequestModal] = useState(false);
  const [changeRequestImpactDataLoading, setChangeRequestImpactDataLoading] =
    useState(false);
  const [changeRequestImpactData, setChangeRequestImpactData] = useState({});

  /**
   * This API will fetch the change request impact analysis details
   *
   * @param {string} entity_uuid - uuid of the entity.
   */
  const getChangeRequestImpactAnalysis = useCallback((params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_IMPACT_ANALYSIS}`,
        { params, loader: false }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  }, []);

  const handleImpactCalculation = useCallback(
    (entityId) => {
      if (!entityId) {
        return;
      }
      setChangeRequestImpactDataLoading(true);
      getChangeRequestImpactAnalysis({ entity_uuid: entityId })
        .then((res) => {
          if (res?.data) {
            setChangeRequestImpactData(res.data);
            setOpenChangeRequestModal(true);
          }
        })
        .finally(() => {
          setChangeRequestImpactDataLoading(false);
        });
    },
    [getChangeRequestImpactAnalysis]
  );

  const handleCloseChangeRequestModal = useCallback(() => {
    setOpenChangeRequestModal(false);
  }, []);

  return {
    getChangeRequestFieldOptions,
    getChangeRequestImpactAnalysis,
    openChangeRequestModal,
    changeRequestImpactDataLoading,
    changeRequestImpactData,
    handleImpactCalculation,
    handleCloseChangeRequestModal,
  };
}
